module.exports = __webpack_public_path__ + "static/media/dnv.5447267e.svg";